import {MasterController} from './master_controller'

export default class extends MasterController {
    static targets = ['code', 'name', 'modal', 'iframe', 'noHeader']

    getParams() {
        return `&customer_single_form[no_header]=true&customer_single_form[code]=${this.codeTarget.value}`
    }

    searchCode(e) {
        super._searchCode(e, 'customers')
    }

    checkCode() {
        super._checkCode('customers')
    }

}
